module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='WindGuru Settings (<a target=\'_blank\' href=\'http://old.windguru.cz/int/webfcst.php\'>help</a>):<br/>\n<textarea id=\'settings\' class=\'field tall json\'>'+
((__t=(JSON.stringify(settings, null, "\t")))==null?'':__t)+
'</textarea>\n';
}
return __p;
};
